import {
  CONSTRUCTION_PHASE_BASIC_ACTIONS_COUNT,
  CONSTRUCTION_PHASE_FIRST_ROUND_ADDITIONAL_ACTIONS
} from "../../../constants/construction";
import {SPECIAL_BUILDING_TOKENS} from "../../../constants/tokens";
import {checkIfHexBlockedByEnemyUnit} from "../checkIfHexBlockedByEnemyUnit";
import {isPlayerPolicy} from "../../factions/isPlayerPolicy";
import {POLICIES} from "../../../constants/policies";
import {POLICY_INDUSTRIALISM_CONSTRUCTION_ACTIONS_BONUS} from "../../../configs/policy/industrialism";
import {isPlayerFaction} from "../../factions/isPlayerFaction";
import {FACTIONS} from "../../../constants/factions";
import {FACTION_ELEMENTALS_CONSTRUCTION_ACTIONS_BONUS} from "../../../configs/factions/elementals";
import {checkIfPlayerBonusApplies} from "../checkIfPlayerBonusApplies";
import {getPlayerBonusValues} from "../getPlayerBonusValues";

export const CONSTRUCTION_ACTIONS_SOURCE_IDS = Object.freeze({
  BASE: 'base',
  FIRST_ROUND: 'first_round',
  PALACES: 'palaces',
  INDUSTRIALISM: 'industrialism',
  ELEMENTALS: 'elementals',
  PLAYER_BONUS: 'player_bonus',
});

/**
 * Сколько дворцов игрока сейчас работает (не заблокированы отрядом противника
 * и не повреждены): каждый дает +1 действие в фазе строительства
 */
export const countWorkingPalaces = (player, citiesCache, units, specialBuildings, buildingsDamage) => {
  let count = 0;
  for (const city of (citiesCache[player.color] || [])) {
    for (const palaceHexKey of (city[SPECIAL_BUILDING_TOKENS.PALACE] || [])) {
      // CRUTCH: hexes = null - допустимо для специальных строений, так как аргумент hexes не используется при расчете их работоспособности
      if (!checkIfHexBlockedByEnemyUnit(palaceHexKey, SPECIAL_BUILDING_TOKENS.PALACE, player.id, units, null, specialBuildings, buildingsDamage)) {
        count += 1;
      }
    }
  }
  return count;
};

/**
 * Из чего складываются действия игрока в фазе строительства раунда — один
 * расчет на начало фазы (редьюсер, START_NEXT_PHASE) и на расшифровку в
 * панели статов шапки
 *
 * @param {Object} player
 * @param {Object} params
 * @param {number} params.round - раунд этой фазы строительства
 * @param {string} params.gameType - getRulesGameType(gameState)
 * @param {number} params.workingPalacesCount - countWorkingPalaces на начало фазы
 * @returns {Array<{id: string, amount: number}>} только ненулевые источники
 */
export const getConstructionActionsSources = (player, {round, gameType, workingPalacesCount}) => {
  const sources = [{id: CONSTRUCTION_ACTIONS_SOURCE_IDS.BASE, amount: CONSTRUCTION_PHASE_BASIC_ACTIONS_COUNT}];

  if (round === 1 && CONSTRUCTION_PHASE_FIRST_ROUND_ADDITIONAL_ACTIONS > 0) {
    sources.push({id: CONSTRUCTION_ACTIONS_SOURCE_IDS.FIRST_ROUND, amount: CONSTRUCTION_PHASE_FIRST_ROUND_ADDITIONAL_ACTIONS});
  }
  if (workingPalacesCount > 0) {
    sources.push({id: CONSTRUCTION_ACTIONS_SOURCE_IDS.PALACES, amount: workingPalacesCount});
  }
  if (isPlayerPolicy(player, POLICIES.INDUSTRIALISM)) {
    sources.push({id: CONSTRUCTION_ACTIONS_SOURCE_IDS.INDUSTRIALISM, amount: POLICY_INDUSTRIALISM_CONSTRUCTION_ACTIONS_BONUS});
  }
  if (isPlayerFaction(player, FACTIONS.ELEMENTALS)) {
    sources.push({id: CONSTRUCTION_ACTIONS_SOURCE_IDS.ELEMENTALS, amount: FACTION_ELEMENTALS_CONSTRUCTION_ACTIONS_BONUS});
  }
  if (checkIfPlayerBonusApplies(player, gameType)) {
    const bonusActions = getPlayerBonusValues(player).constructionActionsBonus;
    if (bonusActions > 0) {
      sources.push({id: CONSTRUCTION_ACTIONS_SOURCE_IDS.PLAYER_BONUS, amount: bonusActions});
    }
  }

  return sources;
};

export const sumConstructionActionsSources = (sources) => (
  sources.reduce((sum, source) => sum + source.amount, 0)
);
